import styled from 'styled-components';
import { FormControlLabel } from '@mui/material';
import { StyledButton as BaseStyledButton } from '@/components/styled/button';

// Question styles
export const FieldInputWrapper = styled.div`
  .MuiFormControlLabel-root {
    border: none;
    background: var(--ripkit-sys-light-surface, #fbfcfe);
    box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.16);
    padding: 0px;
  }

  @media screen and (max-width: 600px) {
    padding: 8px;
  }
`;

export const StyledBottomNavigation = styled.div`
  .MuiButtonBase-root {
    border-radius: 86px;
    height: 40px;
  }
  .MuiButtonBase-root:active,
  .MuiButtonBase-root:focus,
  .MuiButtonBase-root:hover {
    --tw-border-opacity: 1;
    border: 2px solid rgb(134 188 37 / var(--tw-border-opacity));
    --tw-text-opacity: 1;
    color: rgb(134 188 37 / var(--tw-text-opacity));
  }
`;

// EndPage styles
export const ModelName = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 20px;
  color: #1e1e1e;
  text-align: center;
  font-size: 16px;
  font-style: italic;
  line-height: 20px;
  letter-spacing: 2px;
  margin-bottom: 30px;
`;

export const SubTitle = styled.p`
  color: #1e1e1e;
  font-size: 16px;
  font-weight: bold;
  line-height: 25px;
  margin-bottom: 0;
  margin-top: 30px;

  @media screen and (max-width: 600px) {
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 8px;
  }
`;

export const PieCenterLabel = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  pointer-events: none;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #000;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 800;
  line-height: 48px; /* 100% */
  letter-spacing: -0.48px;
  text-anchor: 'middle';
  -webkit-dominant-baseline: 'central';

  @media screen and (max-width: 600px) {
    font-size: 1.2rem;
    line-height: 1.2rem;
  }
`;

export const PieChartsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  margin-top: 32px;
  margin-bottom: 32px;

  @media screen and (max-width: 600px) {
    flex-direction: column;
    margin-top: 12px;
    margin-bottom: 12px;
    gap: 12px;
  }
`;

export const PieWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  width: 250px;

  @media screen and (max-width: 600px) {
    width: 100%;
    min-width: 0;
    padding: 0 4px;
  }
`;

export const ArticleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 35px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const ArticleText = styled.p`
  color: var(--ripkit-black, #000);
  font-family: 'Open Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
  margin-top: 0;
`;

export const ArticleLinkButton = styled.a`
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  text-decoration: none !important;
  display: flex;
  justify-content: center;
  width: 256px;
  height: 31px;
  padding: 0 16px;
  align-items: center;
  flex-shrink: 0;
  border-radius: 4px;
  background: #c4d600;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.08);
  margin-top: 10px;
  cursor: pointer;
  &:focus {
    outline: none;
  }
  &:active {
    opacity: 0.9;
  }

  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;

export const TooltipContent = styled.div`
  width: 100%;
  max-width: 1000px;
  height: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row-reverse;
  align-items: start;
  justify-content: center;
  padding: 10px;
  color: black;

  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`;

export const TooltipIconAndWrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: center;
  gap: 47px;
  color: black;

  @media screen and (max-width: 600px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 224px;
  height: 100%;

  @media screen and (max-width: 600px) {
    width: fit-content;
  }
`;

export const IconCircle = styled.div<{ color: string }>`
  width: 166px;
  height: 166px;
  border-radius: 50%;
  background: ${({ color }) => color || '#c4d600'};
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 600px) {
    width: 90px;
    height: 90px;
  }
`;

export const TooltipTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 100%;
`;

export const ToolTipSubTitle = styled.p`
  font-size: 16px;
  text-align: left;
  margin-bottom: 0;

  @media screen and (max-width: 600px) {
    margin-top: 0;
  }
`;
export const ToolTipText = styled.p`
  font-size: 16px;
  text-align: left;
  margin-top: 10px;
`;

export const ToolTipLinkButton = styled.a`
  font-size: 16px;
  font-style: italic;
  line-height: normal;
  text-decoration-line: underline;
  text-align: left;
  font-weight: bold;
  padding: 0 0 0 10px;
`;

export const TooltipCloseButton = styled.button`
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  z-index: 2;

  @media screen and (max-width: 600px) {
    text-align: right;
    width: 100%;
  }
`;

export const TimelineWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 15px;
  min-height: 60px;

  @media screen and (max-width: 1024px) {
    flex-direction: column;
    gap: 8px;
    min-height: 40px;
    margin-bottom: 16px;
    justify-content: center;
    align-items: center;
  }
`;

// Question styles

export const TimelineLine = styled.div`
  position: absolute;
  top: calc(100% - 24px);
  left: 7%;
  right: -5%;
  z-index: 1;
  height: 4px;
  background: #fff;
  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const TimelineArrow = styled.div`
  position: absolute;
  top: calc(100% - 24px);
  right: -7%;
  z-index: 2;
  width: 32px;
  height: 32px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;

  /* Arrow shape using border */
  &:after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 18px solid #fff;
  }

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const OptionCardStyled = styled.div`
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: border 0.2s;
  margin-bottom: 24px;
  min-width: 320px;
  max-width: 420px;
  width: 100%;

  @media screen and (max-width: 1024px) {
    margin-bottom: 12px;
    min-width: 0;
    max-width: 100%;
  }
`;

export const OptionHeader = styled.div`
  background: #c4d600;
  color: #222;
  font-weight: bold;
  font-style: italic;
  font-size: 0.875rem;
  padding: 12px 20px;
  letter-spacing: 0.5px;
  border-radius: 8px 8px 0 0;

  @media screen and (max-width: 1024px) {
    font-size: 0.75rem;
    padding: 8px 12px;
  }
`;

export const OptionList = styled.ul`
  margin: 0;
  padding: 18px 24px 18px 36px;
  font-size: 0.875rem;
  color: #222;
  list-style: disc;
  background: #fff;
  min-height: 255px;
  border-radius: 0 0 8px 8px;

  @media screen and (max-width: 1024px) {
    padding: 8px 16px 8px 24px;
    font-size: 0.75rem;
    min-height: 120px;
  }
`;

export const OptionListItem = styled.li`
  margin-bottom: 10px;
  line-height: 1.5;

  @media screen and (max-width: 1024px) {
    margin-bottom: 6px;
    font-size: 0.75rem;
  }
`;

export const OptionBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  min-width: 320px;
  max-width: 420px;

  @media screen and (max-width: 1024px) {
    min-width: 0;
    max-width: 100%;
    margin-bottom: 20px;
  }
`;

export const RadioWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 48px;
  z-index: 3;
  @media screen and (max-width: 1024px) {
    height: 32px;
  }
`;

export const StyledFormControlLabel = styled(FormControlLabel)`
  && {
    margin-top: 8px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 5;
    padding: 0;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    @media screen and (max-width: 1024px) {
      margin-top: 4px;
      width: 20px;
      height: 20px;
    }
  }
`;

// Drag And Drop
export const DragAndDropContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  min-height: 476px;
  min-width: 708px;
  width: 100%;
  flex-shrink: 1;
  flex-grow: 0;

  @media screen and (max-width: 600px) {
    flex-direction: column;
    min-width: 0;
    min-height: 300px;
    gap: 10px;
    padding: 10px;
  }
`;

export const DropColumn = styled.div`
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  min-height: 376px;
  flex-shrink: 1;
  @media screen and (max-width: 600px) {
    min-height: 200px;
    padding: 8px;
    gap: 6px;
  }
`;

export const DropRightColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 8px;
  background: #fff;
  width: 100%;
  height: fit-content;
  flex-shrink: 1;
  max-height: 476px;
  min-height: 476px;

  @media screen and (max-width: 600px) {
    max-height: none;
    min-height: 200px;
    padding: 8px;
    gap: 6px;
  }
`;

export const PriorityTitle = styled.p`
  color: #1e1e1e;
  font-style: italic;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 1.6px;
  padding-left: 10px;
  font-size: 0.75rem;
  margin: 0;

  @media screen and (max-width: 600px) {
    font-size: 0.625rem;
    padding-left: 4px;
  }
`;

export const DraggableItem = styled.div`
  color: #000;
  border-radius: 6px;
  cursor: grab;
  font-weight: 500;
  text-align: center;
  #background-color: #fbfcfe;
  border-radius: 4px;
  box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.16);
  height: 100%;
  width: 100%;
  font-size: 0.75rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 600px) {
    font-size: 0.625rem;
    padding: 6px;
  }
`;

export const DraggableTitle = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;
  align-self: stretch;
  border-radius: 4px 4px 0 0;
  background: #c4d600;
  height: fit-content;
  max-height: 5px;
  width: 100%;

  @media screen and (max-width: 600px) {
    padding: 6px;
    font-size: 0.75rem;
  }
`;
export const DraggableContent = styled.div`
  padding: 10px;
  text-align: left;

  @media screen and (max-width: 600px) {
    padding: 6px;
    font-size: 0.75rem;
  }
`;

export const DraggableContentAndTitle = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 600px) {
    justify-content: center;
    align-items: center;
  }
`;

export const Slot = styled.div`
  min-height: 70px;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  border-radius: 4px;
  border: 1px dashed #757575;
  background: rgba(217, 217, 217, 0.1);

  @media screen and (max-width: 600px) {
    min-height: 40px;
  }
`;

export const DownArrow = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 8px;
`;

export const ArrowAndSlotContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 25px;

  @media screen and (max-width: 600px) {
    flex-direction: column;
    padding-left: 0;
    gap: 8px;
  }
`;
export const StyledButton = styled(BaseStyledButton)`
  color: ${({ $buttonColor }) => $buttonColor};
  background: ${({ background }) => background};
  highlight: ${({ highlight }) => highlight};

  /* Additional styles for the button */
  height: 40px;
  font-size: 14px;
  &:active,
  &:focus,
  &:hover {
    --tw-border-opacity: 1;
    border: 2px solid rgb(134 188 37 / var(--tw-border-opacity));
    --tw-text-opacity: 1;
    color: rgb(134 188 37 / var(--tw-text-opacity));
  }
`;
export const StyledProgressHeader = styled.div`
  .MuiLinearProgress-root .MuiLinearProgress-bar {
    background-color: rgb(134 188 37);
  }
`;
